import { StyledAuthFooter } from './style';

import logo from 'assets/images/admin/ui_logo@3x.png';

export const AuthFooter = () => {
  return (
    <StyledAuthFooter>
      <img src={logo} alt="" />
    </StyledAuthFooter>
  );
};
